export const getToken = () => {
  try {
    const t = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    return t && String(t).length > 0 ? t : null;
  } catch {
    return null;
  }
};
